import './traditionalActivity.scss';
import '../assessment-reports/reports.scss';
import studentAttendingTpl from './views/studentAttendingPage.html'
import studentQuestionTpl from './views/studentQuestionSelection.html'

import './traditionalActivity.scss';
import activityListCtrl from './controllers/activityList';
import createActivityCtrl from './controllers/createActivity';
import qpSummaryCtrl from './controllers/qpSummary';
import activityPreviewCtrl from './controllers/activityPreview';
import formatQuestionCtrl from './controllers/formatQuestion';
import viewSubmissionListCtrl from './controllers/viewSubmissionList';
import assignStudentsCtrl from './controllers/assignStudents';
import createStudentGroupCtrl from './controllers/createGroup';
import studentAnswerViewCtrl from './controllers/studentAnswerView';
import teacherAnswerViewCtrl from './controllers/teacherAnswerView';
import studentAttendingCtrl from './controllers/studentAttendingPage';
import studentQuestionCtrl from './controllers/studentQuestionSelection';
import studentViewReportCtrl from './controllers/studentViewReport';
import teacherViewReportCtrl from './controllers/teacherViewReport';
import procturedDocumentController from './controllers/procturedDocumentsController';

import attendeeListCtrl from './controllers/attendeeList';
import reportsMainCtrl from './controllers/reports-main';
import individualStudentTraditionalReportCtrl from './controllers/individual-student-report';
import answersheetPreview from './controllers/answersheetPreview';
import answersheetPreviewTpl from './views/answersheet-preview.html';
import procturedCocumentTpl from './views/procturedDocument.html';

const name = 'activityList';
const createActivity = "createActivity"
const createQuestion = "createQuestion"
var module = angular.module("TraditionalActivityModule", [
]).component('studentAttendingPage', {
    template: studentAttendingTpl,
    controllerAs: 'studentAttendingCtrl',
    controller: studentAttendingCtrl
})
    .component('studentQuestionSelection', {
        template: studentQuestionTpl,
        controllerAs: 'studentQuestionCtrl',
        controller: studentQuestionCtrl
    })
    .component('answersheetPreview', {
        template: answersheetPreviewTpl,
        controller: answersheetPreview,
        controllerAs: 'answersheetPreview'
    })
    .controller('activityListCtrl', activityListCtrl)
    .controller('createActivityCtrl', createActivityCtrl)
    .controller('qpSummaryCtrl', qpSummaryCtrl)
    .controller('activityPreviewCtrl', activityPreviewCtrl)
    .controller('formatQuestionCtrl', formatQuestionCtrl)
    .controller('viewSubmissionListCtrl', viewSubmissionListCtrl)
    .controller('assignStudentsCtrl', assignStudentsCtrl)
    .controller('createStudentGroupCtrl', createStudentGroupCtrl)
    .controller('studentAnswerViewCtrl', studentAnswerViewCtrl)
    .controller('teacherAnswerViewCtrl', teacherAnswerViewCtrl)
    .controller('studentAttendingCtrl', studentAttendingCtrl)
    .controller('studentQuestionCtrl', studentQuestionCtrl)
    .controller('studentViewReportCtrl', studentViewReportCtrl)
    .controller('teacherViewReportCtrl', teacherViewReportCtrl)
    .controller('attendeeListCtrl', attendeeListCtrl)
    .controller('reportsMainCtrl', reportsMainCtrl)
    .controller('individualStudentTraditionalReportCtrl', individualStudentTraditionalReportCtrl)
    .controller('ProcturedDocumentController', procturedDocumentController);
    
module.constant('TPWIZARDCONSTANT', {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs",
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
        // flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../../img/auth/pdf.png",
        // flash: "../../../../../src/img/auth/interactive_anime.png",
        video: '../../../../../img/auth/video.png',
        weblinks: '../../../../../img/auth/web.png',
        refbooks: '../../../../../img/auth/refbook.png',
        activityForm: '../../../../../img/auth/activity.png',
        khanAcademy: '../../../../../img/auth/khan_academy.png',
        utubeVideo: '../../../../../img/auth/utube.png',
        googleDocs: "../../../../../img/auth/google_docs.png",
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_SAVE_WEBLINK: "/v0/tp-resources/weblink/save",
    API_SAVE_REFBOOK: "/v0/tp-resources/refbook/save",
    API_SAVE_GOOGLEDOCS: "/v0/tp-resources/googledoc/save",
    API_SAVE_UTUBE: "/v0/tp-resources/youtube/save",
    API_SAVE_KHANACADEMY: "/v0/tp-resources/khanacademy/save",
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/",
    API_GET_FORMAT_QP: "/v0/tp-activity/format-qp",
    API_GET_TP_ACTIVITY: "/v0/tp-activity/get-activity/",
    API_SAVE_SECTION: "/v0/tp-activity/save-section",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_QUESTION: "/v0/tp-activity/add-questions",
    API_AUTO_FORMAT: "/v0/tp-activity/auto-format",
    API_SELECT_QP: "/v0/tp-activity/create-qp-from-qp",
    API_SELECT_TEMPLATE: "/v0/tp-activity/qp/template",
    API_GET_QP_SUMMARY: "/v0/tp-activity/summary/",
    API_SAVE_FLASH: "/v0/tp-resources/flash/save",
    API_SAVE_VIDEO: "/v0/tp-resources/video/save",
    API_SAVE_PDF: "/v0/tp-resources/pdf/save",
    API_ADD_PDF_ANNOTATION: '/v0/tp-resources/annotation/add-annotation',
    API_FETCH_ANNOTATION: "/v0/tp-resources/annotation/fetch",
    API_REMOVE_ANNOTATION: "/v0/tp-resources/annotation/remove-page-annotation",
    API_UPDATE_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-page-annotation",
    API_UPDATE_ALL_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-all-page-annotation",
    API_APPROVE_RESOURCE: "/v0/tp-resources/approve-resource",
    API_GET_ACTIVITY_REPORT: "/v0/tp-reports/assessment-activity-based-report/",
    API_APPROVE_RESOURCE: "/v0/tp-resources/approve-resource",
    API_GET_STUDENTS: "/v0/tp-reports/student-details",
    API_GET_ALL_ACTIVITY: "/v0/tp-reports/activity-list/",
    API_ADD_LEARNING_PROGRESS: "/v0/tp-resources/learning-progress/save",
    API_ADD_NOTES: "/v0/tp-resources/add-note",
    API_GET_PREV_NOTES: "/v0/tp-resources/get-previous-note",
    API_GET_STUDENT_REPORT: "/v0/tp-reports/assessment-activity-student-based-report/",
    API_GET_ASSIGNED_RESOURCES: "/v0/tp-reports/assigned-resources/",
    API_GET_LEARNING_PROGRESS: "/v0/tp-reports/learning-progress",
    API_GET_ALL_PRACTICE_ACTIVITY: "/v0/tp-reports/practice-activity-list/",
    API_GET_PRACTICE_ACTIVITY_REPORT: "/v0/tp-reports/practice-activity-based-report/",
    API_GET_STUDENT_PRACTICE_REPORT: "/v0/tp-reports/practice-activity-student-based-report/",
    API_COMPLETE_RESOURCE: "/v0/teachingPlan/resource-complete/",
})
module.constant("activityCons", {
    API_GET_ALL_ACTIVITY: "/v0/traditional/get-activity",
    API_GET_STUDENT_ACTIVITY: "/v0/traditional/get-assigned-students/",
    API_GET_TRADITIONAL_ACTIVITY: "/v0/traditional/format-qp/",
    API_GET_THEMES: "/v0/traditional/theme-details",
    API_ADD_ACTIVITY_TO_QP: "/v0/traditional/qp/save",
    API_UPDATE_ACTIVITY_QP: "/v0/traditional/update-title-theme",
    API_GET_STRANDS_WAVE: "/v0/traditional/get-wave-strands-tag/",
    API_GET_QUESTION: "/v0/tp-activity/get-question/",
    API_GET_EXAM_QUESTIONS: "/v0/qp/exam/questions/",
    API_SUBMIT_EXAM_QUESTION: "/v0/qp/exam/answer",
    API_GET_QP_SUMMARY: "/v0/qp/summary",
    API_SUBMIT_EXAM: "/v0/qp/exam/submit",
    API_STOP_EXAM: "/v0/qp/exam/stop",
    API_START_EXAM: "/v0/qp/exam/start",
    API_GET_SCHOOL_DETAILS: "/v0/teachingPlan/school-details/",
    API_CURRENT_DATE: "/v0/teachingPlan/current-date",
    API_ACTIVITY_PREVIEW: "/v0/traditional/activity-preview/",
    API_QP_DETAILS: "/v0/traditional/qp/details/",
    API_GET_QP_DETAILS: "/v0/traditional/qp/details/",
    API_GET_QP_ATTENDEE_DETAILS: "/v0/traditional/qp/attendeelist/",
    API_GET_ANSWER_DETAILS: "/v0/traditional/answer/details/",
    API_GET_EXAM_AND_QB_DETAILS: "/v0/traditional/exam/qb/details/",
    API_UPDATE_EXAM_SCORE: "/v0/traditional/exam/score/update",
    API_SAVE_SECTION: "/v0/traditional/save-section",
    API_SAVE_QP: "/v0/traditional/qp/update",
    API_SAVE_PASSWORD: "/v0/traditional/activity-password/",
    API_UPDATE_ASSIGNEE_DETAILS: "/v0/assign-users/activity-assignee-details",
    API_GET_STUDENT_LIST: "/v0/assign-users/student-details/",
    API_GET_ASSIGNED_USERS: "/v0/assign-users/activity-students/",
    API_GET_GROUP_DETAILS: "/v0/assign-users/get-group-details/",
    API_DELETE_GROUP: "/v0/assign-users/delete-group/",
    API_STUDENT_GROUP_DETAILS: "/v0/assign-users/student-group-details/",
    API_ADD_STUDENT_GROUP: "/v0/assign-users/create-group/",
    API_UPDATE_STUDENT_GROUP: "/v0/assign-users/edit-group/",
    API_GET_FETCH_MY_ANSWER: "/v0/traditional/fetch-answer/",
    SKILL_LIST: ["Analysing", "Applying", "Creating", "Evaluating", "Recall", "Understanding"],
    QUESTION_TYPE_DETAILS: {
        MCQ: "Multiple choice question",
        FIB: "Fill in the blanks",
        MTF: "Match the following",
        OWQ: "One word question",
        TF: "True or False",
        SA: "Short answer question",
        LA: "Long answer question",
        IBT_MCQ: "IBT - Multiple choice question",
        IBT_FIB: "IBT - Fill in the blanks",
        DRAW: "Drawing",
        ASLSPEAK: "ASL - Speaking",
        ASLLISTEN: "ASL - Listening",
        PASSAGE: "Passage"
    },
    API_SELECT_QP: "/v0/traditional/create-qp-from-qp",
    API_SELECT_QUESTION: "/v0/traditional/add-questions",
    API_STUDENT_QUESTION: "/v0/traditional/student/question/",
    API_AUTO_FORMAT: "/v0/traditional/auto-format",
    API_DELETE_QP: "/v0/traditional/delete-qp/",
    API_SCHEDULE_EXAM: "/v0/traditional/update-due-date",
    API_APPROVER_LIST: "/v0/traditional/qp/approvers",
    API_SEND_FOR_APPROVAL: "/v0/traditional/qp/send-for-approval",
    API_APPROVE_QP: "/v0/traditional/qp/approve/",
    API_REJECT_QP: "/v0/traditional/qp/reject/",
    API_PUBLISH_RESULT: "/v0/traditional/publish-result/",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_TEMPLATE: "/v0/traditional/qp/create-from-template",
    API_STUDENT_REPORT: "/v0/traditional/student-report/",
    API_GET_STUDENT_ANSWER_DETAILS : "/v0/traditional/studentanswer/details/"
});

module.config(function ($stateProvider, $urlRouterProvider) {
    "ngInject";
});
module.service('qpHandler', function () {
    return {
        updateParentVisibility: function (authService, args) {
            let url = '/v0/qp/parentvisibility/update'
            let method = "POST"
            let msg = 'now the activity is visible to parents'
            if (!args.is_visibleto_parents) {
                msg = 'now the activity is not visible to parents'
            }
            let req = {
                school_id: args.school_id,
                qp_id: args.qp_id,
                is_visibleto_parents: args.is_visibleto_parents
            }
            authService.callAPI(url, method, req, function (response) {
                if (response.result && response.result.data &&
                    response.result.data.details) {
                    args.toastr.success("Updated, " + msg)
                } else {
                    args.toastr.error("Network error");
                }
            })
        }
    }
})

module.filter('safeHtml', function($sce) {
    return function(val) {
        return $sce.trustAsHtml(val);
    };
});


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/traditionalActivityModule.js